import { CheckIcon, MinusIcon } from '@phosphor-icons/react';

import { cn } from '@utils';

export const CheckBox = ({ id, checked, indeterminate, onChange, ...props }: any) => {
  return (
    <div className="relative inline-flex">
      <input
        {...props}
        type="checkbox"
        id={`checkbox-${id}`}
        className="sr-only"
        onChange={onChange}
        checked={checked}
      />

      <label
        htmlFor={`checkbox-${id}`}
        className={cn(
          'cursor-pointer transition-all duration-200 ease-in-out rounded border flex items-center justify-center hover:shadow-sm size-4',
          'focus-within:ring-1 focus-within:ring-green-500 focus-within:ring-opacity-20 focus-within:outline-none',
          checked || indeterminate
            ? 'bg-green-600 border-green-600 text-white'
            : 'bg-white border-gray-300 hover:border-gray-400',
        )}
      >
        {indeterminate ? (
          <MinusIcon
            className={cn(
              'h-2.5 w-3 transition-all duration-200',
              indeterminate ? 'opacity-100 scale-100' : 'opacity-0 scale-50',
            )}
          />
        ) : (
          <CheckIcon
            className={cn(
              'h-2.5 w-3 transition-all duration-200',
              checked ? 'opacity-100 scale-100' : 'opacity-0 scale-50',
            )}
          />
        )}
      </label>
    </div>
  );
};
